var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetestDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7301 17.9983L13.7301 3.99827C13.5556 3.69048 13.3027 3.43446 12.997 3.25634C12.6913 3.07822 12.3438 2.98437 11.9901 2.98438C11.6363 2.98437 11.2888 3.07822 10.9831 3.25634C10.6774 3.43446 10.4245 3.69048 10.2501 3.99827L2.25005 17.9983C2.07373 18.3036 1.98128 18.6502 1.98206 19.0028C1.98284 19.3554 2.07683 19.7015 2.2545 20.0061C2.43217 20.3107 2.6872 20.5629 2.99375 20.7371C3.30029 20.9113 3.64746 21.0014 4.00005 20.9983H20.0001C20.351 20.9979 20.6956 20.9052 20.9993 20.7296C21.3031 20.5539 21.5553 20.3014 21.7306 19.9974C21.9059 19.6934 21.9981 19.3487 21.998 18.9978C21.9979 18.6469 21.9055 18.3022 21.7301 17.9983Z",
    stroke: "#DC2626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13",
    stroke: "#DC2626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17H12.01",
    stroke: "#DC2626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetestDash);
export default __webpack_public_path__ + "static/media/retest_dash.4acf171d0a320af58be6a2b2591b0627.svg";
export { ForwardRef as ReactComponent };